class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // Filter cart items to show only recently added items
    if (window.recentlyAddedItems && window.recentlyAddedItems.length > 0) {
      const recentlyAddedIds = window.recentlyAddedItems;
      
      // Wait for items to be in the DOM with retry logic
      const filterItems = (attempt = 0) => {
        // Look for cart items in the notification
        const cartItemDivs = document.querySelectorAll('#cart-notification-product [class*="cart-item"]');
        
        // Retry if items not ready yet
        if (cartItemDivs.length === 0 && attempt < 5) {
          setTimeout(() => filterItems(attempt + 1), 100);
          return;
        }
        
        // Give up if still no items found
        if (cartItemDivs.length === 0) {
          window.recentlyAddedItems = null;
          return;
        }
        
        // Filter each cart item - show only recently added
        cartItemDivs.forEach(cartItemDiv => {
          const variantElement = cartItemDiv.querySelector('[data-variant-id]');
          
          if (!variantElement) {
            cartItemDiv.style.display = 'none';
            return;
          }
          
          const variantId = variantElement.getAttribute('data-variant-id');
          const isRecentlyAdded = recentlyAddedIds.includes(String(variantId));
          
          cartItemDiv.style.display = isRecentlyAdded ? '' : 'none';
        });
        
        // Clear the recently added items after filtering
        window.recentlyAddedItems = null;
      };
      
      // Start filtering with a small initial delay
      setTimeout(() => filterItems(), 50);
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `.cart-notification-products-wrapper`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
